export default __webpack_public_path__ + "static/media/bgrb.f266555f.svg";